import ActiveFilterList from './ActiveFilterList';

export default ActiveFilterList;
